import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=6cc1ed35&scoped=true&"
import script from "./ProductPrice.vue?vue&type=script&lang=js&"
export * from "./ProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=6cc1ed35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1ed35",
  null
  
)

export default component.exports